import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import womenBg1 from '../../assets/img/sidhi/11.png';
import womenBg2 from '../../assets/img/sidhi/12.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Women = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [ womenBg1, womenBg2];
     const backgroundImage = images[currentImageIndex];
    return (
      <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Women and Child Care</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Women and Child Care</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Women and Child Care at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Women and Child Care at Hitkari Hospital</h3>
                                     <p>At Hitkari Hospital, we are committed to delivering exceptional healthcare services that cater specifically to the needs of women and children. Combining advanced medical expertise with personalized care, our Women and Child Care Department is designed to support every stage of a woman’s life and provide nurturing care for children from infancy to adolescence.</p>
                                </div>
                                 <div className="terms-text">
                                      <h3>Comprehensive Women’s Health Services</h3>
                                      <br />
                                        <p>Our dedicated team of gynecologists, obstetricians, and specialists ensures holistic care for women. Whether you’re seeking routine screenings or advanced medical interventions, we are here to support your health journey.</p>
                                         <h4>Gynecological Services</h4>
                                        <ul>
                                          <li>Diagnosis and treatment of gynecological conditions such as polycystic ovary syndrome (PCOS), endometriosis, and pelvic inflammatory diseases.</li>
                                          <li>Screening for cervical and ovarian cancer with advanced diagnostic tools.</li>
                                          <li>Menstrual health management and hormone therapy for menopause.</li>
                                        </ul>
                                      <h4>Obstetric Care for Pregnancy</h4>
                                        <ul>
                                          <li>Antenatal care: Monitoring maternal and fetal health with regular check-ups, ultrasounds, and counseling.</li>
                                          <li>Expertise in high-risk pregnancies, including gestational diabetes and preeclampsia management.</li>
                                         <li>Safe delivery options, including vaginal delivery, cesarean sections, and advanced pain relief techniques.</li>
                                          <li>Comprehensive postnatal care for both mother and baby.</li>
                                        </ul>
                                        <h4>Reproductive Health and Fertility Support</h4>
                                        <ul>
                                          <li>Fertility consultations and cutting-edge treatments like ovulation induction and intrauterine insemination (IUI).</li>
                                          <li>Support for managing reproductive challenges, including fibroids and uterine abnormalities.</li>
                                        </ul>
                                       <h4>Preventive Health and Screening</h4>
                                        <ul>
                                          <li>Breast cancer screenings with digital mammography for early detection.</li>
                                          <li>HPV vaccinations to prevent cervical cancer.</li>
                                          <li>Bone health monitoring to prevent and manage osteoporosis.</li>
                                       </ul>
                                </div>
                                 <div className="terms-text">
                                      <h3>Pediatric and Neonatal Care Services</h3>
                                        <br />
                                        <p>Caring for children requires a delicate balance of medical expertise and compassion. At Hitkari Hospital, we ensure your child’s health and well-being with the following services:</p>
                                       <h4>General Pediatric Care</h4>
                                        <ul>
                                          <li>Treatment for common conditions like allergies, asthma, and infections.</li>
                                          <li>Growth tracking and developmental milestone assessments.</li>
                                        </ul>
                                         <h4>Neonatal Intensive Care Unit (NICU)</h4>
                                          <ul>
                                              <li>Specialized care for premature and critically ill newborns.</li>
                                              <li>Advanced neonatal services, including ventilator support, incubators, and phototherapy.</li>
                                           </ul>
                                          <h4>Vaccination and Immunization Programs</h4>
                                            <ul>
                                              <li>Adherence to the latest immunization schedules for maximum protection against diseases.</li>
                                              <li>Awareness campaigns for preventing preventable childhood illnesses.</li>
                                            </ul>
                                           <h4>Nutrition and Wellness Programs</h4>
                                            <ul>
                                               <li>Dietary planning to ensure children meet growth and nutritional milestones.</li>
                                               <li>Counseling for parents on managing childhood obesity and food allergies.</li>
                                            </ul>
                                          <h4>Subspecialty Pediatric Care</h4>
                                            <ul>
                                              <li>Access to pediatric cardiology, endocrinology, neurology, and orthopedics for complex conditions.</li>
                                               <li>Focused care for children with special needs, including developmental delays.</li>
                                            </ul>
                                </div>
                                 <div className="terms-text">
                                     <h3>Facilities and Features</h3>
                                    <br />
                                       <ul>
                                              <li><strong>State-of-the-Art Labor and Delivery Suites:</strong> Ensuring safety and comfort during childbirth with 24/7 monitoring.</li>
                                               <li><strong>Family-Centered NICU Care:</strong> Allowing parents to actively participate in their baby’s recovery process.</li>
                                               <li><strong>Dedicated Lactation Support:</strong> Assistance for new mothers struggling with breastfeeding.</li>
                                              <li><strong>Child-Friendly Environments:</strong> Bright, welcoming spaces to ease anxiety for children during treatments.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital for Women and Child Care?</h3>
                                    <br />
                                    <ul>
                                         <li><strong>Patient-Centered Approach:</strong> Individualized care plans addressing your specific needs.</li>
                                           <li><strong>Holistic Care:</strong> Focus on physical, emotional, and psychological well-being.</li>
                                            <li><strong>Experienced Specialists:</strong> Led by a team of skilled gynecologists, obstetricians, neonatologists, and pediatricians.</li>
                                           <li><strong>Modern Facilities:</strong> Equipped with cutting-edge technology for accurate diagnoses and effective treatments.</li>
                                          <li><strong>Supportive Environment:</strong> Empathetic staff committed to ensuring a positive experience for mothers and children.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Empowering Women and Nurturing the Next Generation</h3>
                                    <br />
                                   <p>At Hitkari Hospital, we believe that empowering women and nurturing children creates a foundation for a healthy and prosperous community. Our team is dedicated to providing exceptional care that emphasizes trust, compassion, and excellence.</p>
                                    <p>Choose Hitkari Hospital for your health journey and experience a blend of modern medicine with a personal touch. Your health and happiness are our priorities.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Women;